import moment from "moment";
import DepositSchedule from "../Config/DepositSchedule";
import {
    getDepositModeConfigValueForKeyWithState,
    getDepositScheduleConfigValueForKeyWithState,
    getPlanTypesConfigValueForKey,
    getProvincialTaxRateConfigForKey,
} from "./ConfigUtil";
import {
    calculateCompletionInsuranceCostForUnits,
    calculateCriticalIllnessInsuranceCostForUnits,
    calculateNomineeInsuranceCostForUnits,
    calculateNomineeInsurancePerUnitCost,
} from "./InsuranceUtils";
import i18n from "i18next";
import { familyIncome } from "./KYCUtils";

const t = i18n.t;

export let PLAN_TYPE_IDS = {
    GROUP: 0,
    SI: 1,
    ACHIEVERS: 2,
    TRANSFER: 100,
};

export let PLAN_TYPES = [
    { label: t("--Select One--"), value: -1 },
    { label: t("Group"), value: 0 },
    { label: t("Self-Initiated"), value: 1 },
    { label: t("Achievers"), value: 2 },
];

export const PLAN_TYPES_UNTRANSLATED = [
    { label: "--Select One--", value: -1 },
    { label: "Group", value: 0 },
    { label: "Self-Initiated", value: 1 },
    { label: "Achievers", value: 2 },
];

export let PLAN2_TYPES = [
    { label: t("None"), value: -1 },
    { label: t("Group"), value: 0 },
    { label: t("Self-Initiated"), value: 1 },
    { label: t("Achievers"), value: 2 },
    { label: t("Transfer"), value: 100 },
];

export let LANGUAGES = [
    { label: t("English"), value: true },
    { label: t("French"), value: false },
];

export let GENDERS = [
    { label: t("Male"), value: 1 },
    { label: t("Female"), value: 0 },
    { label: t("Another Gender"), value: 2 },
    { label: t("Not Provided"), value: 3 },
];

// ON, PQ, AB, BC, SK, NB, NS, NL, PE, MB, YT, NU, NT
export let PROVINCES = [
    { label: t("Not Applicable"), value: "N/A" },
    { label: t("Alberta"), value: "AB" },
    { label: t("British Columbia"), value: "BC" },
    { label: t("Manitoba"), value: "MB" },
    { label: t("New Brunswick"), value: "NB" },
    { label: t("Newfoundland and Labrador"), value: "NL" },
    { label: t("Northwest Territories"), value: "NT" },
    { label: t("Nova Scotia"), value: "NS" },
    { label: t("Nunavut"), value: "NU" },
    { label: t("Ontario"), value: "ON" },
    { label: t("Prince Edward Island"), value: "PE" },
    { label: t("Quebec"), value: "PQ" },
    { label: t("Saskatchewan"), value: "SK" },
    { label: t("Yukon"), value: "YT" },
];

export let INITIAL_DEPOSIT_METHODS = [
    { label: t("Credit Card"), value: "Credit Card" },
    { label: t("PAP"), value: "PAP" },
];

export let ONGOING_DEPOSIT_METHODS = [
    { label: t("Credit Card"), value: "Credit Card" },
    { label: t("PAP"), value: "PAP" },
    { label: t("Coupon"), value: "Coupon" },
];
export let CREDIT_CARD_TYPE = [
    { 'label': t('AMEX'), 'value': 'AMEX' },
    { 'label': t('Mastercard'), 'value': 'Mastercard' },
    { 'label': t('Visa'), 'value': 'Visa' },
]


export let DEPOSIT_FREQUENCIES_FOR_QUOTE = [
    { label: t("Monthly"), value: "M" },
    { label: t("Yearly"), value: "A" },
    { label: t("Lifetime"), value: "T" },
];

// 1st, 8th, 15th, 22nd, 28th
export let REQUESTED_DEPOSIT_DATES = [
    { label: "1st of the month", value: "1st of the month" },
    { label: "8th of the month", value: "8th of the month" },
    { label: "15th of the month", value: "15th of the month" },
    { label: "22nd of the month", value: "22nd of the month" },
    { label: "28th of the month", value: "28th of the month" },
];

//IDs used to identify different recipients in an envelope within DocuSign
export let DR_SIGNER_ID = "1";
export let SUBSCRIBER_SIGNER_ID = "2";
export let JOINT_SUBSCRIBER_SIGNER_ID = "3";
export let PRIMARY_CAREGIVER = "4";
export let BENEFICIARY_SIGNER_ID = "5";
export let THIRD_PARTY_SIGNER_ID = "6";
export let GUARDIAN_SIGNER_ID = "7";

export let POSSIBLE_SIGNERS = {
    "Dealing Representative": DR_SIGNER_ID,
    Subscriber: SUBSCRIBER_SIGNER_ID,
    "Joint Subscriber": JOINT_SUBSCRIBER_SIGNER_ID,
    "Primary Caregiver": PRIMARY_CAREGIVER,
    Beneficiary: BENEFICIARY_SIGNER_ID, // TODO talk to greg about this.
    "Third Party": THIRD_PARTY_SIGNER_ID,
    Guardian: GUARDIAN_SIGNER_ID,
};

i18n.on("init languageChanged", function (lng) {
    PLAN_TYPES = [
        { label: t("--Select One--"), value: -1 },
        { label: t("Group"), value: 0 },
        { label: t("Self-Initiated"), value: 1 },
        { label: t("Achievers"), value: 2 },
    ];

    PLAN2_TYPES = [
        { label: t("None"), value: -1 },
        { label: t("Group"), value: 0 },
        { label: t("Self-Initiated"), value: 1 },
        { label: t("Achievers"), value: 2 },
        { label: t("Transfer"), value: 100 },
    ];

    LANGUAGES = [
        { label: t("English"), value: false },
        { label: t("French"), value: true },
    ];

    GENDERS = [
        { label: t("Male"), value: 1 },
        { label: t("Female"), value: 0 },
        { label: t("Another Gender"), value: 2 },
        { label: t("Not Provided"), value: 3 },
    ];

    // ON, PQ, AB, BC, SK, NB, NS, NL, PE, MB, YT, NU, NT
    PROVINCES = [
        { label: t("Not Applicable"), value: "N/A" },
        { label: t("Alberta"), value: "AB" },
        { label: t("British Columbia"), value: "BC" },
        { label: t("Manitoba"), value: "MB" },
        { label: t("New Brunswick"), value: "NB" },
        { label: t("Newfoundland and Labrador"), value: "NL" },
        { label: t("Northwest Territories"), value: "NT" },
        { label: t("Nova Scotia"), value: "NS" },
        { label: t("Nunavut"), value: "NU" },
        { label: t("Ontario"), value: "ON" },
        { label: t("Prince Edward Island"), value: "PE" },
        { label: t("Quebec"), value: "PQ" },
        { label: t("Saskatchewan"), value: "SK" },
        { label: t("Yukon"), value: "YT" },
    ];

    INITIAL_DEPOSIT_METHODS = [
        { label: t("Credit Card"), value: "Credit Card" },
        { label: t("PAP"), value: "PAP" },
    ];

    ONGOING_DEPOSIT_METHODS = [
        { label: t("Credit Card"), value: "Credit Card" },
        { label: t("PAP"), value: "PAP" },
        { label: t("Coupon"), value: "Coupon" },
    ];
    CREDIT_CARD_TYPE = [
        { 'label': t('AMEX'), 'value': 'AMEX' },
        { 'label': t('Mastercard'), 'value': 'Mastercard' },
        { 'label': t('Visa'), 'value': 'Visa' },
    ]

    DEPOSIT_FREQUENCIES_FOR_QUOTE = [
        { label: t("Monthly"), value: "M" },
        { label: t("Yearly"), value: "A" },
        { label: t("Lifetime"), value: "T" },
    ];

    // 1st, 8th, 15th, 22nd, 28th
    REQUESTED_DEPOSIT_DATES = [
        { label: t("1st of the month"), value: "1st of the month" },
        { label: t("8th of the month"), value: "8th of the month" },
        { label: t("15th of the month"), value: "15th of the month" },
        { label: t("22nd of the month"), value: "22nd of the month" },
        { label: t("28th of the month"), value: "28th of the month" },
    ];
});

export const planNameForPlanTypeIDUntranslated = (planTypeID) => {
    return PLAN_TYPES_UNTRANSLATED.find((plan) => plan.value === planTypeID)
        .label;
};

export const planNameForPlanTypeIDTranslated = (planTypeID) => {
    return PLAN_TYPES.find((plan) => plan.value === planTypeID).label;
};

//Returns the 2 character province code for the given province name
export const provinceShortName = (name) => {
    switch (name) {
        case "Alberta":
            return "AB";
        case "British Columbia":
            return "BC";
        case "Manitoba":
            return "MB";
        case "New Brunswick":
            return "NB";
        case "Newfoundland and Labrador":
            return "NL";
        case "Northwest Territories":
            return "NT";
        case "Nova Scotia":
            return "NS";
        case "Nunavut":
            return "NU";
        case "Ontario":
            return "ON";
        case "Prince Edward Island":
            return "PE";
        case "Quebec":
            return "PQ";
        case "Saskatchewan":
            return "SK";
        case "Yukon":
            return "YT";
        default:
            return name;
    }
};

//Returns a list of descriptors indicating which individuals will need to be part of the signing process for the enrolment package
export const requiredSigners = (state) => {
    const ret = [];
    ret.push("Dealing Representative");
    ret.push("Subscriber");

    if (state.common.subscriber2Include) {
        ret.push("Joint Subscriber");
    }
    return ret;
};

//Calculates the age of the beneficiary based on the birthdate and the current date
export const beneficiaryAge = (birthdate) => {
    if (!birthdate) {
        return 0;
    }
    return moment().diff(birthdate, "years");
};

//calculates the calendar age of the beneficiary as of today
export const beneficiaryCalendarYearsAge = (birthdate) => {
    if (!birthdate) {
        return 0;
    }
    return moment().year() - moment(birthdate).year();
};

//calculates the calendar age of the beneficiary at the maturity date
export const beneficiaryCalendarYearsAgeAtMaturity = (state) => {
    if (!state.plan.maturityDate || !state.beneficiary.birthdate) {
        return 0;
    }
    return (
        moment(state.plan.maturityDate).year() -
        moment(state.beneficiary.birthdate).year()
    );
};

//Returns true if the provincial grant option should be displayed based on the signing province and other rules
export const shouldDisplayProvincialGrantOption = (state) => {
    if (!state.common.signingProvince) {
        return false;
    }
    return (
        state.common.signingProvince === "PQ" ||
        (state.common.signingProvince === "BC" &&
            6 <= beneficiaryCalendarYearsAge(state.beneficiary.birthdate) &&
            beneficiaryCalendarYearsAge(state.beneficiary.birthdate) <= 9)
    );
};

//Group plan is only available if the beneficiary is 13 or younger
export const isGroupPlanAvailable = (state) => {
    return beneficiaryCalendarYearsAge(state.beneficiary.birthdate) <= 13;
};

//CLB Only is an option tha tis only allowed for the SI plan
export const isCLBOnlyAllowed = (state) => {
    return state.plan.planTypeID === PLAN_TYPE_IDS.SI;
};

//returns the number of yeaars to maturity from the effective date
export const yearsToMaturity = (state) => {
    const ret = moment(state.plan.maturityDate).diff(
        moment(state.plan.effectiveDate),
        "years",
    );
    if (isNaN(ret)) {
        return 0;
    }
    return ret;
};

//Returns the maximum carry forward grant room based on the beneficiary's currrent age
export const maxCarryForwardGrantRoom = (state) => {
    return (moment().year() - moment(state.beneficiary.birthdate).year()) * 500;
};

//returns the current age of the subscriber
export const subscriberAge = (state) => {
    return moment().diff(state.subscriber.birthdate, "years");
};

//returns the current age of the joint subscriber
export const jointSubscriberAge = (state) => {
    return moment().diff(state.jointSubscriber.birthdate, "years");
};

//Beneficiary insurance is not allowed for T modes
export const isBeneficiaryInsuranceAllowed = (state) => {
    //not allowed for T modes
    if (state.plan.depositMode === "T") {
        return false;
    }
    return true;
};

//Completion insurance is only allowed for Group plans and not for T modes.
// also not allowed if subscriber or joint subscriber is less than 18 or greater than 72 years old
export const isCompletionInsuranceAllowed = (state) => {
    //Completion Insurance is only allowed for the Group plan
    if (
        [PLAN_TYPE_IDS.SI, PLAN_TYPE_IDS.ACHIEVERS].includes(
            state.plan.planTypeID,
        )
    ) {
        return false;
    }
    //Completion Insurance is not allowed for T modes
    if (state.plan.depositMode === "T") {
        return false;
    }
    //Completion insurance not allowed if subscriber or joint subscriber is less than 18
    // or greater than 72 years old
    if (
        state.subscriber.birthdate &&
        (73 <= subscriberAge(state) || subscriberAge(state) < 18)
    ) {
        return false;
    }
    if (
        state.jointSubscriber.birthdate &&
        73 <= jointSubscriberAge(state) &&
        jointSubscriberAge(state) < 18
    ) {
        return false;
    }

    return true;
};

//CI insurance is only allowed for the Group plan and not for T modes
export const isCriticalIllnessInsuranceAllowed = (state) => {
    //Critical Illness Insurance is only allowed for the Group plan
    if (
        [PLAN_TYPE_IDS.SI, PLAN_TYPE_IDS.ACHIEVERS].includes(
            state.plan.planTypeID,
        )
    ) {
        return false;
    }
    //And not allowed for T modes
    if (state.plan.depositMode === "T") {
        return false;
    }

    //and not allowed if Completion Insurance is not already selected
    if (!state.plan.completionInsurance) {
        return false;
    }
    return true;
};

export const isCriticalIllnessInsuranceAllowedForPlanType = (planTypeID) => {
    return planTypeID === PLAN_TYPE_IDS.GROUP;
};

//This function is intended to round in the same way as the old system (the iPad, which is modeled after the Windows
// quote generator).
// The idea is half numbers are rounded up (to the nearest penny) if the integer portion is odd,
// and rounded down if the integer portion is even
export const round2dec = (num) => {
    //TODO: I believe round2dec in the iPad is the same as roundHalfEven.
    return roundHalfEven(num);
    /*
    const temp = Math.trunc(+(num) * 100.0);
    let ret = temp / 100.0;
    let integer = Math.trunc(num);

    const plusDecimals = Math.trunc(num * 100.0);
    let thousandthsAndMore = num - (plusDecimals / 100.0);
    thousandthsAndMore *= 1000.0;

    if (thousandthsAndMore > 5.0) {
        ret += 0.01;
    } else if (thousandthsAndMore === 5.0 && (integer % 2) === 1) {
        ret += 0.01;
    }

    return ret;
    */
};

//Explicitly round halves up, and round down otherwise
//Default 2 decimals
export const roundHalfUp = (number, decimals = 2) => {
    const factor = Math.pow(10, decimals);
    return Math.round(number * factor) / factor;
};

/*
export const roundHalfUp = (num, decimals) => {
    if (!decimals) { decimals = 2; }
    let multiplier = Math.pow(10, decimals);
    let temp = num *  multiplier;
    temp = Math.round(temp);
    return temp / multiplier;
}

 */

//Explicitly round halves to the closest even number
//Default 2 decimals
export const roundHalfEven = (number, decimals = 2) => {
    const factor = Math.pow(10, decimals);
    const roundedNumber = Math.round(number * factor) / factor;
    const difference = roundedNumber - (number * factor) / factor;

    if (difference === 0.5 || difference === -0.5) {
        if (Math.floor(roundedNumber) % 2 === 0) {
            // It's already even
            return roundedNumber;
        } else {
            // Adjust to the nearest even number
            return (
                (Math.floor(number * factor) + (difference > 0 ? 0 : -1)) /
                factor
            );
        }
    }

    return roundedNumber;
};

/*
export const roundHalfEven = (num, decimals) => {
    if (!decimals) { decimals = 2; }
    let multiplier = Math.pow(10, decimals);
    num *= multiplier;

    const floored = Math.floor(num);
    const decimal = num - floored;

    if (decimal !== 0.5) {
        return Math.round(num) / multiplier ;
    }

    if ((floored % 2) === 0) {
        return floored / multiplier;
    } else {
        return (floored + 1) / multiplier;
    }
}

 */

//Returns the different deposit modes available for the given plan type
export const depositModesForPlanTypeUntranslated = (planTypeID) => {
    return Object.keys(
        DepositSchedule[planNameForPlanTypeIDUntranslated(planTypeID)],
    ).map((key) => {
        return {
            value: key,
            label: `${key} - ${DepositSchedule[planNameForPlanTypeIDUntranslated(planTypeID)][key].ModeName}`,
        };
    });
};

export const depositModesForPlanTypeTranslated = (planTypeID) => {
    return Object.keys(
        DepositSchedule[planNameForPlanTypeIDUntranslated(planTypeID)],
    ).map((key) => {
        return {
            value: t(key),
            label: `${t(key)} - ${t(DepositSchedule[planNameForPlanTypeIDUntranslated(planTypeID)][key].ModeName)}`,
        };
    });
};

//Returns the lifetime deposit amount for the given state
// either including or excluding the insurance cost
export const calculateLifetimeDepositAmount = (
    state,
    includeInsuranceCost,
    roundInsuranceTo2Decimals,
) => {
    let ret = 0; //Ultimately will contain the lifetime amount expected to be deposited
    let depositAmount = 0;
    let numberOfAdditionalDeposits = 0;
    //For some reason, in a couple of places for Achievers we round half even to match the iPad...
    const roundFunction =
        state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS
            ? roundHalfEven
            : roundHalfUp;

    if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
        numberOfAdditionalDeposits =
            getDepositScheduleConfigValueForKeyWithState(
                state,
                "NumberOfAdditionalDeposits",
            );
        let depositAmount = getDepositScheduleConfigValueForKeyWithState(
            state,
            "InitialDeposit",
        );
        depositAmount *= numberOfAdditionalDeposits + 1;
        ret = depositAmount; // * state.plan.numberOfUnits;
    } else if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
        numberOfAdditionalDeposits =
            getDepositModeConfigValueForKeyWithState(
                state,
                "NumberOfDepositsPerYear",
            ) * state.plan.depositCode;
        numberOfAdditionalDeposits -= 1;
        depositAmount = getPlanTypesConfigValueForKey(
            planNameForPlanTypeIDUntranslated(state.plan.planTypeID),
            "CostPerUnit",
        );
        ret = depositAmount;
    } else if (state.plan.planTypeID === PLAN_TYPE_IDS.SI) {
        //SI has one required deposit - just the initial one.
        numberOfAdditionalDeposits = 0;
        ret = roundFunction(state.plan.depositAmount);
    }

    if (state.plan.planTypeID !== PLAN_TYPE_IDS.SI) {
        ret *= state.plan.numberOfUnits;
        ret = roundFunction(ret);
    }

    if (includeInsuranceCost) {
        let insuranceCost =
            calculateCompletionInsuranceCostForUnits(
                state,
                roundInsuranceTo2Decimals,
            ) *
            (numberOfAdditionalDeposits + 1);
        insuranceCost +=
            calculateNomineeInsuranceCostForUnits(
                state,
                roundInsuranceTo2Decimals,
            ) *
            (numberOfAdditionalDeposits + 1);
        insuranceCost +=
            calculateCriticalIllnessInsuranceCostForUnits(
                state,
                roundInsuranceTo2Decimals,
            ) *
            (numberOfAdditionalDeposits + 1);

        ret += insuranceCost;
    }

    return ret;
};

//Returns the yearly deposit amount for the given state
// either including or excluding the insurance cost
export const calculateYearlyDepositAmount = (
    state,
    includeInsuranceCost,
    roundInsuranceTo2Decimals,
) => {
    if (state.plan.depositCode < 1) {
        return 0;
    }

    let ret = 0; //Ultimately will contain the lifetime amount expected to be deposited
    let depositAmount = 0;
    let depositsPerYear = 0;

    if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
        depositAmount = getDepositScheduleConfigValueForKeyWithState(
            state,
            "AdditionalDeposit",
        );
        depositsPerYear = getDepositModeConfigValueForKeyWithState(
            state,
            "NumberOfDepositsPerYear",
        );
    } else if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
        depositAmount = getPlanTypesConfigValueForKey(
            planNameForPlanTypeIDUntranslated(state.plan.planTypeID),
            "CostPerUnit",
        );
        if (state.plan.depositMode !== "T") {
            depositsPerYear = getDepositModeConfigValueForKeyWithState(
                state,
                "NumberOfDepositsPerYear",
            );
            depositAmount /= state.plan.depositCode;
        }
    } else if (state.plan.planTypeID === PLAN_TYPE_IDS.SI) {
        depositsPerYear = getDepositModeConfigValueForKeyWithState(
            state,
            "NumberOfDepositsPerYear",
        );
        ret = roundHalfUp(state.plan.depositAmount / state.plan.depositCode);
    }

    if (state.plan.planTypeID !== PLAN_TYPE_IDS.SI) {
        ret = depositAmount * state.plan.numberOfUnits;

        if (roundInsuranceTo2Decimals) {
            ret = roundHalfUp(ret);
        }

        //TODO: The iPad says this is a kludge...
        if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
            ret *= depositsPerYear;
        }
    }

    if (includeInsuranceCost) {
        let insuranceCost =
            calculateCompletionInsuranceCostForUnits(
                state,
                roundInsuranceTo2Decimals,
            ) * depositsPerYear;
        insuranceCost +=
            calculateNomineeInsuranceCostForUnits(
                state,
                roundInsuranceTo2Decimals,
            ) * depositsPerYear;
        insuranceCost +=
            calculateCriticalIllnessInsuranceCostForUnits(
                state,
                roundInsuranceTo2Decimals,
            ) * depositsPerYear;
        ret += insuranceCost;
    }

    return ret;
};

//Returns a new copy of the state with the given number of units instead
export const newStateWithUnits = (state, newUnits) => {
    return {
        ...state,
        plan: {
            ...state.plan,
            numberOfUnits: newUnits,
        },
    };
};

//Returns the number of units that can be purchased with the given monthly amount
export const calculateNumberOfUnitsFromMonthlyDepositAmount = (
    state,
    amount,
) => {
    let ret = 1.0;

    if (state.plan.planTypeID === PLAN_TYPE_IDS.SI) {
        return 1.0; //SI Always has 1 unit
    }

    if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
        amount *= 12; // Consider one year of contributions

        if (state.plan.depositMode === "T") {
            //Figure out the lifetime cost for one unit
            const oneUnitCost = calculateLifetimeDepositAmount(
                newStateWithUnits(state, 1),
                true,
                false,
            );
            const divide = amount / oneUnitCost;
            ret = roundHalfUp(divide, 3);
        } else {
            amount *= state.plan.depositCode; //Consider the number of years of contributions
            let oneUnitCost = calculateYearlyDepositAmount(
                newStateWithUnits(state, 1),
                true,
                false,
            );
            //Since Nominee Insurnace is not per unit, we need to remove the Nominee Insurance cost from both the "oneUnitCost" amount,
            //And from the amount passed to this method.
            const numDepositsPerYear = getDepositModeConfigValueForKeyWithState(
                state,
                "NumberOfDepositsPerYear",
            );
            const nomineeInsuranceCostPerYear =
                calculateNomineeInsurancePerUnitCost(state, true) *
                numDepositsPerYear;
            //oneUnitCost -= nomineeInsuranceCostPerYear * state.plan.depositCode;
            const tempAmount =
                amount - nomineeInsuranceCostPerYear * state.plan.depositCode;
            const divide = tempAmount / oneUnitCost;
            ret = roundHalfUp(divide, 3);
        }
    }

    if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
        amount *= 12; // Consider one year of contributions

        if (state.plan.depositMode === "T") {
            //Figure out the lifetime cost for one unit
            const oneUnitCost = calculateLifetimeDepositAmount(
                newStateWithUnits(state, 1),
                true,
                false,
            );
            const divide = amount / oneUnitCost;
            ret = roundHalfUp(divide, 3);
        } else {
            let oneUnitCost = calculateYearlyDepositAmount(
                newStateWithUnits(state, 1),
                true,
                false,
            );
            const numDepositsPerYear = getDepositModeConfigValueForKeyWithState(
                state,
                "NumberOfDepositsPerYear",
            );
            const nomineeInsuranceCostPerYear =
                calculateNomineeInsurancePerUnitCost(state, true) *
                numDepositsPerYear;
            oneUnitCost -= nomineeInsuranceCostPerYear;
            const tempAmount = amount - nomineeInsuranceCostPerYear;
            const divide = tempAmount / oneUnitCost;
            ret = roundHalfUp(divide, 3);
        }
    }
    return ret;
};

//Returns the monthly deposit amount for the given state
export const calculateMonthlyDepositAmount = (state, includeInsuranceCost) => {
    let ret = calculateYearlyDepositAmount(state, includeInsuranceCost, true);
    ret /= 12.0;
    ret = roundHalfUp(ret);
    return ret;
};

//Returns the number of units that can be purchased with the given yearly amount
export const calculateNumberOfUnitsFromLifetimeDepositAmount = (
    state,
    amount,
) => {
    let ret = 1.0;
    if (state.plan.planTypeID === PLAN_TYPE_IDS.SI) {
        return ret;
    }

    if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
        ret = amount;
        let numberOfDeposits = getDepositModeConfigValueForKeyWithState(
            state,
            "NumberOfDepositsPerYear",
        );
        numberOfDeposits *= state.plan.depositCode;
        let oneUnitCost = calculateLifetimeDepositAmount(
            newStateWithUnits(state, 1),
            true,
            false,
        );
        const NICost =
            calculateNomineeInsurancePerUnitCost(state, true) *
            numberOfDeposits;
        oneUnitCost -= NICost;
        //ret -= NICost
        ret /= oneUnitCost;
    }

    if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
        ret = amount;
        const numberOfAdditionalDeposits =
            getDepositScheduleConfigValueForKeyWithState(
                state,
                "NumberOfAdditionalDeposits",
            );
        let oneUnitCost = calculateLifetimeDepositAmount(
            newStateWithUnits(state, 1),
            true,
            false,
        );
        const NICost =
            calculateNomineeInsurancePerUnitCost(state, false) *
            (numberOfAdditionalDeposits + 1);
        oneUnitCost -= NICost;
        ret -= NICost;
        ret /= oneUnitCost;
    }

    ret = roundHalfUp(ret, 3);
    return ret;
};

//Returns the number of units that can be purchased with the given yearly amount
export const calculateNumberOfUnitsFromYearlyDepositAmount = (
    state,
    amount,
) => {
    let ret = 1.0;
    if (state.plan.planTypeID === PLAN_TYPE_IDS.SI) {
        return ret;
    }

    if (state.plan.depositMode === "T") {
        //Figure out the lifetime cost for one unit
        const oneUnitCost = calculateLifetimeDepositAmount(
            newStateWithUnits(state, 1),
            true,
            false,
        );
        const divide = amount / oneUnitCost;
        ret = roundHalfUp(divide, 3);
    } else {
        let oneUnitCost = calculateYearlyDepositAmount(
            newStateWithUnits(state, 1),
            true,
            false,
        );
        const numDepositsPerYear = getDepositModeConfigValueForKeyWithState(
            state,
            "NumberOfDepositsPerYear",
        );
        const nomineeInsuranceCostPerYear =
            calculateNomineeInsurancePerUnitCost(state, true) *
            numDepositsPerYear;
        oneUnitCost -= nomineeInsuranceCostPerYear;
        const tempAmount = amount - nomineeInsuranceCostPerYear;
        const divide = tempAmount / oneUnitCost;
        ret = roundHalfUp(divide, 3);
    }

    ret = roundHalfUp(ret, 3);
    return ret;
};

//Returns the per-deposit amount required for the given state
export const calculatePlanDepositAmount = (state) => {
    let ret = 0.0;

    if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
        ret =
            getDepositScheduleConfigValueForKeyWithState(
                state,
                "InitialDeposit",
            ) * state.plan.numberOfUnits;
    } else if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
        ret = getPlanTypesConfigValueForKey(
            planNameForPlanTypeIDUntranslated(state.plan.planTypeID),
            "CostPerUnit",
        );
        if (state.plan.depositMode !== "T") {
            ret /=
                getDepositModeConfigValueForKeyWithState(
                    state,
                    "NumberOfDepositsPerYear",
                ) * state.plan.depositCode;
        }
        ret = roundHalfUp(ret * state.plan.numberOfUnits);
    } else if (state.plan.planTypeID === PLAN_TYPE_IDS.SI) {
        ret = state.plan.depositAmount;
        //The code below is intended to match what is done with the SIPlanDepositAmount field in the iPad
        // Basically that field is intended to be the lifetime amount for the SI plan
        if (state.quote.depositFrequency === "M") {
            ret *= 12.0 * state.plan.depositCode;
        } else if (state.quote.depositFrequency === "A") {
            ret *= state.plan.depositCode;
        }
        if (state.plan.depositCode !== 0) {
            //Prevent divide by 0
            if (state.plan.depositMode !== "T") {
                ret /=
                    getDepositModeConfigValueForKeyWithState(
                        state,
                        "NumberOfDepositsPerYear",
                    ) * state.plan.depositCode;
            } else {
                //TODO: This is noted as a hack in the iPad
                ret /= state.plan.depositCode;
            }
        }
    }
    ret = roundHalfUp(ret);
    return ret;
};

export const enrolmentValidation = (state) => {
    let retErrors = []; //array of errors

    if (state.plan.planTypeID < 0) {
        retErrors.push({
            message: t("Cannot enrol unless at least one plan is setup"),
            autoNavigate: {
                navigationControllerItemName: t("First Plan"),
                inputItem: "plan.planTypeID",
            },
        });
    }
    if (!state.subscriber.firstName && !state.subscriber.lastName) {
        retErrors.push({
            message: t("Subscriber 1 Name is required"),
            autoNavigate: {
                navigationControllerItemName: t("Subscribers"),
                inputItem: "subscriber.givenName",
            },
        });
    }
    if (!state.subscriber.email) {
        retErrors.push({
            message: t("Subscriber 1 E-Mail address is a required field"),
            autoNavigate: {
                navigationControllerItemName: t("Subscribers"),
                inputItem: "subscriber.email",
            },
        });
    }
    if (!state.subscriber.investmentExperience) {
        retErrors.push({
            message: t(
                "Subscriber 1 Investment Experience is a required field",
            ),
            autoNavigate: {
                navigationControllerItemName: t("Know your Client"),
                inputItem: "subscriber.investmentExperience",
            },
        });
    }

    if (state.common.subscriber2Include) {
        if (
            !state.jointSubscriber.firstName &&
            !state.jointSubscriber.lastName
        ) {
            retErrors.push({
                message: t("Subscriber 2 Name is required"),
                autoNavigate: {
                    navigationControllerItemName: t("Subscribers"),
                    inputItem: "subscriber2.givenName",
                },
            });
        }
        if (!state.jointSubscriber.email) {
            retErrors.push({
                message: t("Subscriber 2 E-Mail address is a required field"),
                autoNavigate: {
                    navigationControllerItemName: t("Subscribers"),
                    inputItem: "subscriber2.email",
                },
            });
        }
        if (!state.jointSubscriber.investmentExperience) {
            retErrors.push({
                message: t(
                    "Subscriber 2 Investment Experience is a required field",
                ),
                autoNavigate: {
                    navigationControllerItemName: t("Know your Client"),
                    inputItem: "subscriber2.investmentExperience",
                },
            });
        }
    }

    if (
        !(
            state.subscriber.primaryCaregiver ||
            (state.common.subscriber2Include &&
                state.jointSubscriber.primaryCaregiver)
        )
    ) {
        //Custodian must sign
        if (
            !state.application.custodianFirstName &&
            !state.application.custodianLastName
        ) {
            retErrors.push({
                message: t("Guardian Name is required"),
                autoNavigate: {
                    navigationControllerItemName: t("Guardian"),
                    inputItem: "custodian.givenName",
                },
            });
        }
        if (!state.application.custodianEmail) {
            retErrors.push({
                message: t("Guardian E-Mail Address is a required field"),
                autoNavigate: {
                    navigationControllerItemName: t("Guardian"),
                    inputItem: "application.custodianEmail",
                },
            });
        }
    }

    if (!state.knowYourClient.riskTolerance) {
        retErrors.push({
            message: t("Know your Client Risk Tolerance is a required field"),
            autoNavigate: {
                navigationControllerItemName: t("Know your Client"),
                inputItem: "riskTolerance",
            }
        });
    }
    if (!state.knowYourClient.objective) {
        retErrors.push({
            message: t("Know your Client Objective is a required field"),
            autoNavigate: {
                navigationControllerItemName: t("Know your Client"),
                inputItem: "objective",
            },
        });
    }

    let calc = state.knowYourClient.deposits || 0;
    calc += state.knowYourClient.securities || 0;
    calc += state.knowYourClient.otherAssets || 0;
    calc -= state.knowYourClient.liabilities || 0;
    if (calc == 0) {
        retErrors.push({
            message: t(
                "Know your Client Approximate Net Worth is a required field",
            ),
            autoNavigate: {
                navigationControllerItemName: t("Know your Client"),
                inputItem: "deposits",
            },
        });
    }

    if (!state.common.prospectusDate) {
        retErrors.push({
            message: t("Prospectus Date is a required field"),
            autoNavigate: {
                navigationControllerItemName: t("Know your Client"),
                inputItem: "prospectusDate",
            },
        });
    }

    if (!state.subscriber.mobilePhone) {
        retErrors.push({
            message: t("Subscriber 1 Mobile Phone is a required field"),
            autoNavigate: {
                navigationControllerItemName: t("Subscribers"),
                inputItem: "subscriber.mobilePhone",
            },
        });
    }

    if (state.common.subscriber2Include && !state.jointSubscriber.mobilePhone) {
        retErrors.push({
            message: t("Subscriber 2 Mobile Phone is a required field"),
            autoNavigate: {
                navigationControllerItemName: t("Subscribers"),
                inputItem: "subscriber2.mobilePhone",
            },
        });
    }

    if (
        !(
            state.subscriber.primaryCaregiver ||
            (state.common.subscriber2Include &&
                state.jointSubscriber.primaryCaregiver)
        )
    ) {
        //Custodian must sign

        if (!state.application.custodianMobilePhone) {
            retErrors.push({
                message: t("Guardian Mobile Phone is a required field"),
                autoNavigate: {
                    navigationControllerItemName: t("Guardian"),
                    inputItem: "application.custodianMobilePhone",
                },
            });
        }
    }

    if (beneficiaryShouldSign(state)) {
        if (!state.beneficiary.firstName && !state.beneficiary.lastName) {
            retErrors.push({
                message: t("Beneficiary Name is required"),
                autoNavigate: {
                    navigationControllerItemName: t("Beneficiary"),
                    inputItem: "beneficiary.givenName",
                },
            });
        }
        if (!state.beneficiary.email) {
            retErrors.push({
                message: t("Beneficiary E-Mail address is a required field"),
                autoNavigate: {
                    navigationControllerItemName: t("Beneficiary"),
                    inputItem: "beneficiary.email",
                },
            });
        }
        if (!state.beneficiary.mobilePhone) {
            retErrors.push({
                message: t("Beneficiary Mobile Phone is a required field"),
                autoNavigate: {
                    navigationControllerItemName: t("Beneficiary"),
                    inputItem: "beneficiary.mobilePhone",
                },
            });
        }
    }
    return retErrors;
};

export function hasTemporarySin(state) {
    let subscriberTempSin = false;

    if (state.subscriber.sin) {
        let sinString = state.subscriber.sin.toString();

        subscriberTempSin =
            sinString && sinString.length === 9 && sinString.startsWith("9");
    }

    let jointSubscriberTempSin = false;
    if (state.common.subscriber2Include && state.jointSubscriber.sin) {
        let sinString = state.jointSubscriber.sin.toString();

        jointSubscriberTempSin =
            sinString && sinString.length === 9 && sinString.startsWith("9");
    }

    return subscriberTempSin || jointSubscriberTempSin;
}

//Returns the number with a suffix (st, nd, rd, th)
export function nth(n) {
    return `${n}${["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th"}`;
}

//puts plan2 into the plan 1 spot - this is useful when passing the state for projections, for example, which will be done based on the information int he first plan
//Except CLB which is turned off for the second plan, and it's done in this sort of weird way since the grantCanadaLearningBond is in the application state and not in the
//plan state
export function stateWithPlan2AsPrimary(state) {
    return {
        ...state,
        plan: state.plan2,
        quote: state.quote2,
        application: {
            ...state.application,
            grantCanadaLearningBond: false, //CLB is always turned off for the second plan
        },
    };
}

export const beneficiaryShouldSign = (state) => {
    const subscriber = state.subscriber;
    const jointSubscriber = state.jointSubscriber;
    const beneficiary = state.beneficiary;
    const subscriber2Include = state.common.subscriber2Include;

    let pcgSin;

    if (subscriber.primaryCaregiver) {
        pcgSin = subscriber.sin;
    } else if (subscriber2Include && jointSubscriber.primaryCaregiver) {
        pcgSin = jointSubscriber.sin;
    } else {
        pcgSin = "";
    }

    let beneIsSubscriber = pcgSin === beneficiary.sin;

    return (
        beneficiaryAge(state.beneficiary.birthdate) >= 18 && !beneIsSubscriber
    );
};

export const incomeWarning = (state) => {
    const fIncome = familyIncome(state);
    if (!fIncome) {
        return false;
    }
    const amountMonthly = calculateMonthlyDepositAmount(state, true);
    if (fIncome < 15000 && amountMonthly > 50) {
        return true;
    }
    if (fIncome < 30000 && amountMonthly > 125) {
        return true;
    }
    if (fIncome < 50000 && amountMonthly > 210) {
        return true;
    }
    return false;
};
